import React, { useState } from 'react';
import {
  Box,
  Menu,
  MenuItem
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';

const ChatHeader = ({
  title,
  onClose,
  onClearChat,
  onShowAllChats,
  isLoading = false,
  isStreaming = false
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleNewChat = () => {
    handleMenuClose();
    if (onClearChat) {
      onClearChat();
    }
  };

  const handleAllChats = () => {
    handleMenuClose();
    if (onShowAllChats) {
      onShowAllChats();
    }
  };
  return (
    <Box>
      {/* Top header - Action buttons only */}
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-end',
          padding: '0 16px',
          height: '56px',
          borderBottom: '1px solid lightGray',
          gap: 2
        }}
      >
        <span
          onClick={handleMenuClick}
          style={{
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            fontSize: '14px'
          }}
        >
          <MoreHorizIcon data-testid="MoreHorizIcon" style={{ color: 'black', fontSize: '16px' }} />
        </span>
        {onClose && (
          <span
            onClick={onClose}
            style={{
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center'
            }}
          >
            <CloseIcon data-testid="CloseIcon" aria-label="close chat" style={{ color: 'black', fontSize: '16px' }} />
          </span>
        )}

        <Menu
          anchorEl={anchorEl}
          open={open}
          onClose={handleMenuClose}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          slotProps={{
            paper: {
              sx: {
                minWidth: 180
              }
            }
          }}
        >
          <MenuItem
            onClick={handleNewChat}
            disabled={isLoading || isStreaming}
            sx={{
              fontSize: '14px',
              py: 1.5,
              px: 2,
              '&.Mui-disabled': {
                opacity: 0.5
              }
            }}
          >
            New Chat
          </MenuItem>
          <MenuItem
            onClick={handleAllChats}
            disabled={isLoading || isStreaming}
            sx={{ 
              fontSize: '14px', 
              py: 1.5, 
              px: 2,
              '&.Mui-disabled': {
                opacity: 0.5
              }
            }}
          >
            View All Chats
          </MenuItem>
        </Menu>
      </Box>

      {/* Bottom header - Title */}
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          padding: '10px 30px',
          height: '80px'
        }}
      >
        <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
          <h2
            style={{
              fontWeight: 500,
              fontSize: '30px',
              marginBottom: '7px',
              marginTop: 0
            }}
          >
            Ask Delve AI
          </h2>
          <div
            style={{
              fontSize: '14px',
              marginTop: 0,
              color: 'rgba(0, 0, 0, 0.6)'
            }}
          >
            about {title}
          </div>
        </Box>
      </Box>
    </Box>
  );
};

export default ChatHeader;